import { render } from "./navComp.vue?vue&type=template&id=4a83504c&scoped=true"
import script from "./navComp.vue?vue&type=script&lang=js"
export * from "./navComp.vue?vue&type=script&lang=js"

import "./navComp.vue?vue&type=style&index=0&id=4a83504c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a83504c"]])

export default __exports__